'use client'
import {
  getGameImageURL,
  POPUP_CONSTANTS,
  useModalLink,
} from '@l2p/apps-shared'
import { useConfig, useIsAuthorized } from '@l2p/swr-hooks'
import { useLocale } from 'next-intl'
import { useRouter } from 'next/navigation'
import React, { memo, useCallback } from 'react'
import Image from '../../Image'
import styles from '../DesktopGameCard/styles.module.scss'
import { MobileGameCardProps } from '../types'

const MobileGameCard: React.FC<MobileGameCardProps> = ({
  title,
  className,
  gameId,
  clickEvent = () => {},
  gameCardPlaceholder,
  gameInfoModalKey,
  slug,
}) => {
  const router = useRouter()
  const signUpUrl = useModalLink(POPUP_CONSTANTS.SIGN_UP_MODAL, true)
  const isAuth = useIsAuthorized()
  const lang = useLocale()
  const gameInfoLink = useModalLink(`${gameInfoModalKey}${slug}`)
  const gameLink = `/${lang}/game/${slug}`
  const instantGameLink = isAuth ? gameLink : signUpUrl
  const globalConfig = useConfig()

  const openInfoModal = useCallback(() => {
    clickEvent?.()

    if (globalConfig?.gameCardMobileOpenGameInstant) {
      router.push(instantGameLink)
    } else {
      router.push(gameInfoLink)
    }
  }, [
    instantGameLink,
    clickEvent,
    router,
    gameInfoLink,
    globalConfig?.gameCardMobileOpenGameInstant,
  ])

  return (
    <div
      className={`${styles.gameWrapper} ${className ? className : ''}`}
      onClick={openInfoModal}
    >
      <div className={`${styles.gameCover} gameCover`}>
        <Image
          objectFit={globalConfig?.gameCardImageBack ? 'contain' : undefined}
          src={getGameImageURL(gameId)}
          alt={title}
          placeholder={gameCardPlaceholder}
          rootMargin="0px"
        />
      </div>
      {globalConfig?.gameCardImageBack && (
        <div className={styles.gameBlueCover}>
          <Image src={getGameImageURL(gameId)} alt={title} />
        </div>
      )}
    </div>
  )
}
export default memo(MobileGameCard)
